module.exports = __webpack_public_path__ + "static/media/Realize-Icon-Blue.7396c198.png";